import { Stack } from '@mui/material';
import {
  SettingCard,
} from '@/components';
import ClassSettings from '@/components/editor/settings/ClassSettings';
import TextFormatSettings from '@/components/editor/settings/TextFormatSettings/TextFormatSettings';
import BackgroundSettings from '@/components/editor/settings/BackgroundSettings/BackgroundSettings';
import SpacingSettings from '@/components/editor/settings/SpacingSettings/SpacingSettings';
import DisplaySettings from '@/components/editor/settings/DisplaySettings/DisplaySettings';

const TextSettings = () => {
  return (
    <Stack spacing={2}>
      {/* ✅ */}
      <SettingCard title="Clases CSS">
        <ClassSettings />
      </SettingCard>
      <SettingCard title="Formato">
        <TextFormatSettings />
      </SettingCard>
      <SettingCard title="Visualización">
        <DisplaySettings />
      </SettingCard>
      <SettingCard title="Fondo">
        <BackgroundSettings />
      </SettingCard>
      <SettingCard title="Espaciado">
        <SpacingSettings />
      </SettingCard>
    </Stack>
  );
};

export default TextSettings;
